<div *ngIf="iframeUrl" id="casino-frm" class="casino__details position-relative">
    <!-- <div class="row">
        <div class="col-md-6">
            <a (click)="back()">
                <i class="fa fa-home"></i>
                <img src="assets/img/{{env.host.name}}/logo.png" alt="Exchange" class="img-fluid logo">
            </a>
        </div>
        <div class="col-md-6">
            <h4>{{gameName}}</h4>
            <div class="casino_user">
                <i class="fa fa-user"></i>
                <span>{{userData?.username}}</span>
            </div>
        </div>
    </div> -->
    <!-- <iframe scrolling="yes" [src]='iframeUrl | safeURL' allowfullscreen="true" title="game" id="casino-link"></iframe> -->
    <iframe #iframe scrolling="yes" [src]="iframeUrl | safeURL" allowfullscreen="true" title="game" id="casino-link"></iframe>
    <app-loader *ngIf="isLoad"></app-loader>
</div>